(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-helpful-resources"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHelpfulResources(root) {
      if (!root || root.getAttribute('data-hc-hr-ready') === 'true') return;
      root.setAttribute('data-hc-hr-ready', 'true');

      var viewport = root.querySelector('[data-hc-hr-viewport]');
      var slides = root.querySelectorAll('[data-hc-hr-slide]');
      var dots = root.querySelectorAll('[data-hc-hr-dot]');
      var prev = root.querySelector('[data-hc-hr-prev]');
      var next = root.querySelector('[data-hc-hr-next]');
      if (!viewport || slides.length < 2) return;

      var current = 0;
      var scrollTimer = null;

      function goTo(index) {
        var total = slides.length;
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        viewport.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        setActive(index);
      }

      function setActive(index) {
        current = index;
        for (var i = 0; i < dots.length; i++) {
          var on = i === index;
          dots[i].classList.toggle('is-active', on);
          if (on) {
            dots[i].setAttribute('aria-current', 'true');
          } else {
            dots[i].removeAttribute('aria-current');
          }
        }
      }

      function indexFromScroll() {
        var width = viewport.clientWidth || 1;
        var index = Math.round(viewport.scrollLeft / width);
        if (index < 0) index = 0;
        if (index > slides.length - 1) index = slides.length - 1;
        return index;
      }

      viewport.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = indexFromScroll();
          if (index !== current) setActive(index);
        }, 60);
      });

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(current - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goTo(current + 1);
        });
      }

      for (var d = 0; d < dots.length; d++) {
        dots[d].addEventListener('click', function (event) {
          goTo(parseInt(event.currentTarget.getAttribute('data-hc-hr-dot'), 10) || 0);
        });
      }

      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          goTo(current - 1);
        } else if (event.key === 'ArrowRight') {
          goTo(current + 1);
        }
      });

      window.addEventListener('resize', function () {
        viewport.scrollLeft = slides[current].offsetLeft - slides[0].offsetLeft;
      });
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-hc-hr]');
      for (var i = 0; i < roots.length; i++) initHelpfulResources(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
